import { Accordion } from "@/components/molecules/Accordion";
import { allAccordions } from "./variables";

export const Faq = () => {
  const FaqElement = document.createElement("div");
  FaqElement.className =
    "app-container border border-gray-100 divide-y divide-gray-100 bg-white";

  allAccordions.forEach((accordionProps) => {
    FaqElement.appendChild(Accordion(accordionProps));
  });

  return FaqElement;
};
